import CompanyServices from "@/services/CompanyServices.js";

export default {
  getCompanyDetails: CompanyServices.getDetails,
  verifyCompanySpvPassword: CompanyServices.verifySpvPassword,
  patchCompanyDetails: CompanyServices.patchDetails
}